import { InputField } from '@eventbrite/eds-input-field';
import { gettext } from '@eventbrite/i18n';
import PropTypes from 'prop-types';
import React from 'react';
import './EmailField.scss';

const ConfirmEmailField = ({
    field,
    errors,
    touched,

    required,
    buttonClasses,
    isStatic,
    onBlur,
    onChange,
    autoFocus,
    bottomSpacing,
}: any) => {
    // User are unable to login when the page is loading, due to "dynamic" style of the input.
    // When a loading state for LookupForm component were implemented, we should remove this prop.
    const style = isStatic ? 'static' : 'dynamic';

    const _handlePaste = (e: any) => {
        // Avoid paste in input
        e.preventDefault();
    };

    const shouldShowErrors =
        (touched.emailConfirmation && !!errors.emailConfirmation) ||
        (!field.value && !!errors.emailConfirmation);

    return (
        <div className={buttonClasses}>
            <InputField
                id="emailConfirmation"
                name="emailConfirmation"
                label={gettext('Confirm email')}
                type="email"
                role="textbox"
                style={style}
                onBlur={onBlur}
                onChange={onChange}
                data-testid="auth-lib-confirm-email-field"
                autoFocus={autoFocus}
                field={field}
                required={required}
                hasError={shouldShowErrors}
                annotationNote={shouldShowErrors && errors?.emailConfirmation}
                bottomSpacing={bottomSpacing}
                onPaste={_handlePaste}
            />
        </div>
    );
};

ConfirmEmailField.propTypes = {
    buttonClasses: PropTypes.string,
    required: PropTypes.bool,
    submitFailed: PropTypes.bool,
    isStatic: PropTypes.bool,
    autoFocus: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFormReset: PropTypes.func,
};

export default ConfirmEmailField;
